<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card flat>
      <v-card-title> Choose an account </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="select"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          outlined
          hide-no-data
          hide-details
          label="Search customer"
          return-object
          item-text="Name"
          
        ></v-autocomplete>
        <template v-if="select">
          <section class="pa-2">
            <div><label>Customer:</label> {{ select.Customer }}</div>
            <div><label>License:</label> {{ select.License }}</div>
            <div><label>Profile:</label> {{ select.Profile }}</div>
          </section>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn :loading="progress" depressed color="primary" @click="login" :disabled="!select">
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import jwtdecode from "jwt-decode";
export default {
  props: {
    dialog: Boolean,
    text: String,
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      progress: false,
    };
  },
  watch: {
    search(val) {
      if (val && val.length >= 3 && val !== this.select) {
        setTimeout(() => {
          this.querySelections(val);
        }, 300);
      }
    },
  },
  methods: {
    login() {
        this.progress = true;
      this.$http
        .loginAsCustomer({
          id: this.select.Id,
        })
        .then((res) => {
          if (res.data) {
            if (jwtdecode(res.data)["QRLOG"]) {
              this.$noty.success('<i class="fas fa-check"></i>');
              localStorage.setItem("auth", res.data);
              localStorage.setItem("user", jwtdecode(res.data).name);

              this.$router.go();
            } else {
              this.$noty.error(this.$t("noaccess"));
              this.progress = false;
            }
          } else {
            this.$noty.error(this.$t("userNotFound"));
            this.progress = false;
          }
        })
        .catch(err => {
            console.log(err)
        });
    },
    querySelections(v) {
      if(!v) return
      if(v.length < 3) return
      this.loading = true;
      this.$http
        .getAccounts(v)
        .then((res) => {
          this.loading = false;
          this.items = res.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/SuperUser.vue